import React, { useEffect, useState } from "react";
import SettlementFormModal from "./SettlementFormModal";

const EditSettlementButton = ({
  columnData,
  updateAtmedSettlementsSurgeryConsultation,
  getAllAtmedSettlementsSurgeryConsultation,
}) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [formData, setFormData] = useState(false);

  const showModal = () => {
    setModalVisible(true);
  };
  const hideModal = () => {
    setModalVisible(false);
  };
  const onSubmit = async (data) => {
    const payloadObj = {
      id: columnData.id,
      payload: { surgery_booking: data },
    };
    hideModal();
    await updateAtmedSettlementsSurgeryConsultation(payloadObj);
    await getAllAtmedSettlementsSurgeryConsultation(undefined, 20, 1);
  };

  useEffect(() => {
    setFormData(columnData);
  }, [modalVisible]);

  return (
    <>
      <SettlementFormModal
        data={formData}
        onSubmit={onSubmit}
        onCancel={hideModal}
        visible={modalVisible}
        title={`Update Settlement Status - ${columnData.booking_id}`}
        keyName={"surgery_booking"}
        updateAtmedSettlementsSurgeryConsultation={
          updateAtmedSettlementsSurgeryConsultation
        }
        getAllAtmedSettlementsSurgeryConsultation={
          getAllAtmedSettlementsSurgeryConsultation
        }
        id={columnData.id}
        submitText="Update"
      />
      <div onClick={showModal}> Edit Status</div>
    </>
  );
};
export default EditSettlementButton;
